export const formatTime = (date, locale) => {
  if (date) {
    return new Intl.DateTimeFormat(locale, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(date));
  }
  return null;
};
